<div class="content content--page">
  <div class="content__inner">
    <div class="content__main content__main--page">
      <div class="card">
        <h1 class="card__title">Activity</h1>
        <div class="card__content">
          <div class="notif notif--activity">
            @for (activity of activities; track activity.id) {
            <div class="notif-item">
              <div class="notif-item__date">{{ activity.dateSent | date:'MMM dd, yyyy' }}</div>
              <div class="notif-item__text" [innerHTML]="activity.content"></div>
            </div>
            }
          </div>
        </div>
        @if (loading) {
        <div class="loading-update">
          <div class="loading-update__loader loader"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        </div>
        }
      </div>
    </div>
  </div>
</div>
